import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';

import { actions, selectors } from '../../redux/modules/modal';

class Modal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    }

    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  handleDialogClose(modal) {
    this.props.close(modal)
  }

  renderModals() {
    return _.map(this.props.modal, m => {
      const isTitleString = typeof m.title === 'string';
      const isContentString = typeof m.content === 'string';

      return (
        <div
          id="sdsModalDialog"
          className={classnames('sds-modal-wrapper sds-modal-wrapper--gray', { 'sds-modal-wrapper--show': this.state.show })}
          key={m.id}
          onClose={() => this.handleDialogClose(m)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="sds-modal sds-modal--form">
            <header className="sds-modal__header">
              <div className="sds-subtitle-small">
                {isTitleString &&
                  <FormattedMessage id={m.title} values={m.params} />
                }
                {!isTitleString &&
                  m.title
                }
              </div>
              <button
                className="sds-btn sds-btn--flat sds-btn--flat-secondary sds-modal-btn__desktop"
                onClick={() => this.handleDialogClose(m)}
              >
                Fechar
		            <i className="material-icons sds-btn__icon sds-btn--right">close</i>
              </button>
              <button
                className="sds-btn-icon sds-btn-icon--flat sds-modal-btn__mobile"
                onClick={() => this.handleDialogClose(m)}
              >
                <i className="material-icons">close</i>
              </button>
            </header>
            <div className="sds-modal__body">
              {isContentString &&
                <FormattedMessage id={m.content} values={m.params} />
              }
              {!isContentString &&
                m.content
              }
            </div>
          </div>
          <div className="sds-modal__overlay" onClick={() => this.handleDialogClose(m)}></div>
        </div>
      );
    })
  }

  render() {
    if (_.isEmpty(this.props.modal)) {
      return null;
    }

    setTimeout(
      () => {
        this.setState({ show: true });
      }, 0
    );

    return (
      <div>
        {this.renderModals()}
      </div>
    );
  }
}

Modal.propTypes = {
  modal: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    modal: selectors.getModals(state)
  };
}

const mapDispatchToProps = {
  close: actions.close
};

export default compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(Modal);